export default function initializeJobOffersLatest() {
    document.querySelectorAll('.block-job-offers-latest').forEach((block) => {
        const swiperEl = block.querySelector('.block-job-offers-latest__swiper');
        if (!swiperEl) return;
        new JobOffersLatestSlider(block);
    });
}

class JobOffersLatestSlider {
    constructor(block) {
        this.block = block;
        this.sliderContainer = this.block.querySelector('.block-job-offers-latest__slider');
        this.swiperInstance = null;
        this.init();
    }

    init() {
        this.loadSlides();
    }

    loadSlides() {
        if (typeof jobOffersAjax === 'undefined' || !this.sliderContainer) {
            if (typeof jobOffersAjax === 'undefined') {
                console.error('jobOffersAjax is not defined');
            }
            return;
        }

        const params = new URLSearchParams();
        const blockId = this.sliderContainer.dataset.blockId || '';
        const slidesPerView = this.sliderContainer.dataset.slidesPerView || '2';
        const selectedCategories = this.sliderContainer.dataset.selectedCategories || '';

        params.append('block_id', blockId);
        params.append('lang', jobOffersAjax.lang || 'pl');
        params.append('slides_per_view', slidesPerView);

        selectedCategories
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
            .forEach((termId) => {
                params.append('block_selected_categories[]', termId);
            });

        fetch(`${jobOffersAjax.restUrl}/latest?${params.toString()}`, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((result) => {
                if (!result || result.html === undefined) {
                    console.error('Error loading latest job offers:', result);
                    return;
                }

                const wrapper = this.block.querySelector('.swiper-wrapper');
                if (!wrapper) {
                    return;
                }

                wrapper.innerHTML = result.html;

                import('swiper/bundle').then(({ default: Swiper }) => {
                    this.initSwiper(Swiper);
                });
            })
            .catch((error) => {
                console.error('AJAX error:', error);
            });
    }

    initSwiper(Swiper) {
        const slider = this.block.querySelector('.block-job-offers-latest__swiper');
        if (!slider) return;

        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
        }

        const slidesPerView = slider.dataset.items ? parseInt(slider.dataset.items, 10) : 2;
        const validSlidesPerView = Number.isNaN(slidesPerView) || slidesPerView < 1 ? 2 : Math.min(slidesPerView, 6);

        this.swiperInstance = new Swiper(slider, {
            speed: 400,
            loop: false,
            spaceBetween: 24,
            slidesPerView: validSlidesPerView,
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            pagination: {
                el: this.block.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: Math.min(validSlidesPerView, 2),
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: validSlidesPerView,
                    spaceBetween: 24,
                },
            },
        });
    }
}
